import { useState, useImperativeHandle, forwardRef } from "react";

const Tooltip = forwardRef(function Tooltip({ styles }, ref) {
  const [state, setState] = useState(null);

  function show(data) {
    setState({
      label: data.label,
      value: data.value,
      segment: data.segment,
      x: data.x,
      y: data.y,
    });
  }

  function move(x, y) {
    setState((prev) => (prev ? { ...prev, x, y } : null));
  }

  function hide() {
    setState(null);
  }

  useImperativeHandle(ref, () => ({ show, move, hide }));

  if (!state) return null;

  return (
    <div
      style={{
        position: "fixed",
        left: state.x + 12,
        top: state.y - 16,
        background: styles.background,
        color: styles.color,
        padding: "6px 10px",
        borderRadius: styles.borderRadius,
        fontSize: styles.fontSize,
        pointerEvents: "none",
        whiteSpace: "nowrap",
        zIndex: 10,
      }}
    >
      <strong>{state.value}: </strong> {state.segment?.name ?? state.label}
    </div>
  );
});

export { Tooltip };
